(function (root, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  root.POTealiumPageSections = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  function normalizeRawValue(value) {
    if (value === null || value === undefined) return '';
    return String(value).trim();
  }

  function compactHierarchy(values, maxDepth) {
    const compacted = [];
    const resolvedMaxDepth = Number.isInteger(maxDepth) && maxDepth > 0 ? maxDepth : 3;

    values.forEach((value) => {
      const normalizedValue = normalizeRawValue(value);
      if (!normalizedValue) return;
      if (compacted[compacted.length - 1] === normalizedValue) return;
      if (compacted.length >= resolvedMaxDepth) return;
      compacted.push(normalizedValue);
    });

    return compacted;
  }

  function findMenuPath(nodes, currentHandle, parentPath) {
    if (!Array.isArray(nodes) || !currentHandle) return [];

    for (let index = 0; index < nodes.length; index += 1) {
      const node = nodes[index];
      if (!node || typeof node !== 'object') continue;

      const nextPath = parentPath.concat(node.section || node.handle || '');

      if (node.handle === currentHandle) {
        return compactHierarchy(nextPath);
      }

      const childPath = findMenuPath(node.children || [], currentHandle, nextPath);
      if (childPath.length > 0) {
        return childPath;
      }
    }

    return [];
  }

  function resolveMenuHierarchy(menuTree, currentHandle) {
    return findMenuPath(menuTree, normalizeRawValue(currentHandle), []);
  }

  function resolveBreadcrumbHierarchy(handles, leafValue) {
    const breadcrumbPath = Array.isArray(handles)
      ? handles.filter((handle) => normalizeRawValue(handle).toLowerCase() !== 'home')
      : [];

    return compactHierarchy(breadcrumbPath.concat(leafValue || ''));
  }

  function applyPageSectionHierarchy(payload, hierarchy) {
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
      return payload;
    }

    const resolvedHierarchy = compactHierarchy(Array.isArray(hierarchy) ? hierarchy : []);

    payload.Page_Section1 = resolvedHierarchy[0] || '';
    payload.Page_Section2 = resolvedHierarchy[1] || '';
    payload.Page_Section3 = resolvedHierarchy[2] || '';

    return payload;
  }

  return {
    applyPageSectionHierarchy,
    compactHierarchy,
    resolveBreadcrumbHierarchy,
    resolveMenuHierarchy,
  };
});
